<template>
    <div class="echarts-pie-box">
        <p class="echarts-pie-title" :title="title">{{title}}</p>
        <div ref="echart" class="echarts-pie-wrap"></div>
    </div>
</template>

<script>
import echarts from 'echarts'
import {mixinCreateEchart} from '@/views/TheHome/mixins/createEchart'
import * as _ from 'lodash'

export default {
  name: 'pie',
  mixins: [mixinCreateEchart],
  props: {
    value: Array,
    title: String
  },
  data () {
    return {
      option: {
        color: ['#F57F31', '#F0BB58', '#58D9AC', '#43C4E2', '#66A2FC', '#3A90E8', '#576BF2', '#6E69FE', '#8366FC',
          '#AD71E9'],
        backgroundColor: '#fff',
        title: {
          show: false,
          text: this.title,
          padding: [2, 0, 0, 0],
          textStyle: {
            fontSize: 16
          }
        },
        grid: {
          top: '15',
          left: '0',
          // right: '3%',
          bottom: 0,
          containLabel: true
        },
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return `${params.name}: ${params.value} ${params.data.unit}<br/>${params.percent}%`
          }, // '{b}: {c}{@unit} <br/>{d}%',
          confine: true
        },
        legend: {
          align: 'left',
          orient: 'vertical',  //垂直显示
          y: 30,    //延Y轴居中
          formatter: function (name) {
            if (document.body.clientWidth < 1200) {
              return name.length > 10 ? name.substr(0, 8) + '...' : name
            } else {
              return name
            }
          },
          x: 'right', //居右显示
          type: 'scroll' // 过多分页
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['30%', '50%'],
            center: ['25%', '55%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '12',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: []
          }
        ]
      },
      echart: null
    }
  },
  methods: {
    // 输入新值 渲染
    changeEchart () {
      let option = {
        series: this.value
      }
      this.echart.setOption(option)
      if (!this.value || !this.value.length) {
        this.echart.showLoading('nodatas')
      }
    }
  }
}
</script>

<style scoped lang="scss">
    .echarts-pie-box {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .echarts-pie-wrap {
        /*padding: 18px 24px;*/
        background: #ffffff;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
    }

    .echarts-pie-title {
        position: absolute;
        top: 0;
        left: 0;
        width: calc(100% - 95px);
        font-size: 16px;
        font-weight: bolder;
        color: #303133;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        z-index: 2;
    }
</style>
